<template>
  <div></div>
</template>

<script>
import { setToken, getToken, deleteToken } from "@/utils/cookies";

export default {

  created() {
    console.log('***********')
    localStorage.removeItem('status')
    localStorage.removeItem('status1')
    if (this.$route.query.from) {
      var queryData = this.$route.query;
      const { accessKey = '', from = '' } = queryData;
      if (accessKey) {
        setToken(accessKey)
      }
      if (from === 'app_pm' && !accessKey) {
        deleteToken();
      }
      const token = getToken();
      // 用户中心首冲进入

      if (token) {

        //h5携带参数截取
        localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=') ? str.split("a=")[1] : '');
        this.toInter()
      } else {
        this.toLogin()
      }
    }

    else {
      this.toCenter();

    }
  },
  methods: {
    toCenter() {
      window.location.href =
         window.location.origin + "/uc/login?" + "live=intergral";
    },
    // 去登录
    toLogin() {
      // 在安卓app
      if (window.android) {
        window.android.gotoLogin();
        //  关闭当前页面
        window.android.finish();
        return
      }
      // 在ios
      if (window.webkit) {
        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === 'visible') {
            console.log("-----用户从其他页面返回");
            if (localStorage.getItem('status1')) {
              window.webkit.messageHandlers.finish.postMessage("1");

            }
          } else {
            console.log("-----用户离开了页面");
            localStorage.setItem('status1', 1)

          }
        });
        window.webkit.messageHandlers.gotoLogin.postMessage("1")//  关闭当前页面

        return
      }
      if (window.ReactNativeWebView) {
        const message = JSON.stringify({ method: 'gotoLogin', data: '' });
        window.ReactNativeWebView.postMessage(message);
        return
      }
    },
    toInter() {
      // 在安卓app
      if (window.android) {
        window.android.gotoIntegral();
        //  关闭当前页面
        window.android.finish();
        return
      }
      // 在ios
      if (window.webkit) {


        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === 'visible') {
            console.log("-----用户从其他页面返回");
            if (localStorage.getItem('status')) {
              window.webkit.messageHandlers.finish.postMessage("1");

            }
          } else {
            console.log("-----用户离开了页面");
            localStorage.setItem('status', 1)

          }
        });

        window.webkit.messageHandlers.gotoIntegral.postMessage('1');
        return
      }
      if (window.ReactNativeWebView) {
        const message = JSON.stringify({ method: 'gotoIntegral', data: '' });
        window.ReactNativeWebView.postMessage(message);
        return
      }

    }
  }
}
</script>

<style></style>
